import React from 'react';
import AssetViewer from './AssetViewer';
import { GridLayout } from './ui';
//import styled from '../themes/themed-styled-components';


type PdfViewerProps = {
    url: string
}

//const PdfDocumentContainer = styled.div`
//    height: 100%;
//    display: flex;
//    flex-grow: 1;
//    flex-direction: column;
//    overflow: hidden;
//    .react-pdf__Document {
//        position: relative;
//        flex-grow: 1;
//        color: #fff;
//        background-color: #000;
//        padding: 20px;
//    }
//    .react-pdf__message {
//        min-height: 100%;
//    }
//    .react-pdf__Page {
//        display: flex; 
//        justify-content: center;
//    }
//`;

const PdfViewer = ({ url }: PdfViewerProps) => {
    //useEffect(() => {
    //    console.log(url);
    //}, [url])

    //function onDocumentLoadSuccess({ numPages }) {
    //    setNumPages(numPages);
    //}

    //function onDocumentLoadError() {
    //    setNumPages(0);
    //}

    //const navbar = useMemo(() => numPages === 0 ? null : <Navbar>
    //    <Nav navbar>
    //        <NavItem>
    //            <NavLink href={url} target="_blank">Apri nel browser</NavLink>
    //        </NavItem>
    //    </Nav>
    //</Navbar>, [url]);

    //const footer = useMemo(() => numPages === 0 ? null : <p>Pagina {pageNumber} di {numPages}</p>, [pageNumber, numPages])

    //const document = useMemo(() => <Document
    //    file={url}
    //    renderTextLayer={true}
    //    error="Errore nel caricamento del file"
    //    onLoadSuccess={onDocumentLoadSuccess}
    //    onLoadError={onDocumentLoadError}
    //    loading={<CenteredContainer><Loading /></CenteredContainer>}
    //>
    //    <Page pageNumber={pageNumber} />
    //</Document>, [url]);

    return (
        //<GridLayout header={navbar} footer={footer}>
        //    <PdfDocumentContainer>
        //        {document}

        //    </PdfDocumentContainer>
        //</GridLayout>
        <GridLayout>
            <AssetViewer src={url} />
        </GridLayout>
    );
}

export default PdfViewer;